// VT220 Terminal Effects

function initTerminal() {
  // Generate session ID
  const sessionEl = document.getElementById('session-id');
  if (sessionEl && !sessionEl.dataset.terminalProcessed) {
    const hex = Array.from(crypto.getRandomValues(new Uint8Array(4)))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('').toUpperCase();
    sessionEl.textContent = 'SESSION: ' + hex;
    sessionEl.dataset.terminalProcessed = 'true';
  }

  // Typing animation for elements with data-terminal-type attribute
  const typeElements = document.querySelectorAll('[data-terminal-type]');

  typeElements.forEach((element, index) => {
    // Skip if already processed
    if (element.dataset.terminalProcessed) return;

    // Store original text before we modify anything
    const text = element.dataset.terminalText || element.textContent.trim();
    element.dataset.terminalText = text;
    element.dataset.terminalProcessed = 'true';

    const speed = parseInt(element.dataset.typeSpeed) || 30;
    const delay = parseInt(element.dataset.typeDelay) || (index * 500);
    const hasCursor = element.hasAttribute('data-terminal-cursor');

    element.textContent = '';
    element.style.visibility = 'visible';

    setTimeout(() => {
      typeText(element, text, speed, hasCursor);
    }, delay);
  });

  // Terminal link click effect
  document.querySelectorAll('a').forEach(link => {
    if (link.dataset.terminalProcessed) return;
    link.dataset.terminalProcessed = 'true';

    link.addEventListener('click', (e) => {
      if (!e.ctrlKey && !e.metaKey) {
        screenFlash('navigate');
      }
    });
  });

  // Random subtle screen flicker (only set up once)
  if (!window.terminalFlickerInitialized) {
    window.terminalFlickerInitialized = true;
    setInterval(() => {
      if (Math.random() < 0.02) {
        screenFlicker();
      }
    }, 2000);
  }

  // Boot sequence if present
  const bootSequence = document.querySelector('[data-terminal-boot]');
  if (bootSequence && !sessionStorage.getItem('terminalBooted')) {
    sessionStorage.setItem('terminalBooted', 'true');
    bootSequence.dataset.terminalProcessed = 'true';
    runBootSequence(bootSequence);
  } else if (bootSequence && !bootSequence.dataset.terminalProcessed) {
    // Show final boot state without animation on subsequent Turbo navigations
    bootSequence.dataset.terminalProcessed = 'true';
    const lines = bootSequence.dataset.terminalBoot.split('|');
    bootSequence.innerHTML = lines.map(l => '<div class="boot-line">' + l + '</div>').join('');
    bootSequence.style.visibility = 'visible';
  }
}

function typeText(element, text, speed, addCursorWhenDone = false) {
  let i = 0;
  element.textContent = '';

  const type = () => {
    if (i < text.length) {
      element.textContent += text.charAt(i);
      i++;
      setTimeout(type, speed + Math.random() * 20);
    } else {
      if (addCursorWhenDone) {
        const cursor = document.createElement('span');
        cursor.className = 'terminal-cursor';
        cursor.textContent = '_';
        element.appendChild(cursor);
      }
      element.dispatchEvent(new CustomEvent('typeComplete'));
    }
  };
  type();
}

function screenFlash(type = 'navigate') {
  const flash = document.createElement('div');
  flash.className = `screen-flash screen-flash-${type}`;
  document.body.appendChild(flash);
  setTimeout(() => flash.remove(), 150);
}

function screenFlicker() {
  document.body.classList.add('screen-flicker');
  setTimeout(() => {
    document.body.classList.remove('screen-flicker');
  }, 50 + Math.random() * 100);
}

function runBootSequence(container) {
  const lines = container.dataset.terminalBoot.split('|');
  container.innerHTML = '';
  container.style.visibility = 'visible';

  let lineIndex = 0;

  const addLine = () => {
    if (lineIndex < lines.length) {
      const line = document.createElement('div');
      line.className = 'boot-line';
      container.appendChild(line);

      typeText(line, lines[lineIndex], 15, false);
      line.addEventListener('typeComplete', () => {
        lineIndex++;
        setTimeout(addLine, 200);
      });
    }
  };

  addLine();
}

document.addEventListener('DOMContentLoaded', initTerminal);
document.addEventListener('turbo:load', initTerminal);
